<template>
    <div
    v-html = "contentTitle"
    class="info-title"
    >            
    </div>
</template>
  
<script>

export default {
    name: 'InfoTitle',
    props: {
        contentTitle: String
    }    
}
</script>
  
<style>
    
</style>
  